const PictViewClass = require('pict-view');
const libPictSectionPDFJS = require('pict-section-pdfjs');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class ObservationDetails extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.ActiveObservationDetails = {};
		this.ObservationDetailsBackTo = null;
		this.ObservationDetailsBackToSet = false;

		// if the observation type is a PDF, use an embed tag, otherwise use an img tag
		this.pict.MetaTemplate.addPattern('{~PreviewImage:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpValue = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			const isPDF = tmpValue?.Details?.File?.[0]?.Datum?.FileMimeType === 'application/pdf';
			const isVideo = tmpValue?.Details?.Video?.[0]?.ArtifactType?.toLowerCase() === 'video';
			const isAudio = tmpValue?.Details?.Audio?.[0]?.ArtifactType?.toLowerCase() === 'audio';
			const isImage = tmpValue?.Details?.Image?.[0]?.ArtifactType?.toLowerCase() === 'image';
			let tmpIDArtifact;
			let tmpVersion;
			// show a PDF viewer if the observation is a PDF file type
			if (isPDF)
			{
				tmpIDArtifact = tmpValue?.Details?.File?.[0]?.IDArtifact;
				tmpVersion = tmpValue?.Details?.File?.[0]?.Version;
				const template = /*html*/`
				<div class="has-background-text-40" id="PDFJS-Container-Div" style="width: 100%; height: 500px; max-height: 500px; overflow: hidden;"></div>
				<div class="image-floated-button buttons" style="box-shadow: none;">
					<button type="button" style="box-shadow: var(--panels-button-shadow);" title="Add Markup Observation" class="button is-warning is-rounded mr-2" onclick="_Pict.views.ObservationDetails.handlePDFNotesButtonClick(event)">
						<span class="icon">
							<i class="fa fa-fw fa-sticky-note"></i>
						</span>
						<span>Add Markup Observation</span>
					</button>
				</div>`;
				return template;
			}
			// show a video player if the observation is a video file type
			else if (isVideo)
			{
				tmpIDArtifact = tmpValue?.Details?.Video?.[0]?.IDArtifact;
				tmpVersion = tmpValue?.Details?.Video?.[0]?.Version;
				return `<video autoplay muted class="has-background-text-40" style="width: 500px; height: auto" controls><source src="/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}" type="video/mp4"></video>`;
			}
			// show an audio player if the observation is an audio file type
			else if (isAudio)
			{
				tmpIDArtifact = tmpValue?.Details?.Audio?.[0]?.IDArtifact;
				tmpVersion = tmpValue?.Details?.Audio?.[0]?.Version;
				return `<audio class="has-background-text-40" style="width: 500px; height: 75px; padding: 10px" controls><source src="/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}" type="audio/mp3"></audio>`;
			}
			else if (isImage)
			{
				// if the observation is locked, don't show the annotate button
				if (this.pict.AppData.DocumentData?.ReportData?.Locked)
				{
					return '';
				}
				const template =
				`<img class="has-background-text-40 detail-image" src="/1.0/Observation/${tmpValue.IDObservation}/Image/Preview?t=${ new Date().getTime() }" alt="Observation Preview" onload="_Pict.views.HeadlightPanels.removeLoadingSkeleton(this)" />
				<button type="button" title="Annotate observation" class="button is-warning is-rounded image-floated-button" onclick="_Pict.views.ObservationDetails.handleAnnotationButtonClick(event)">
					<span class="icon">
						<i class="fa fa-fw fa-pen"></i>
					</span>
					<span>Annotate</span>
				</button>`;
				return template;
			}
			else
			{
				return `<img class="has-background-text-40 detail-image" src="/1.0/Observation/${tmpValue.IDObservation}/Image/Preview?t=${ new Date().getTime() }" alt="Observation Preview" onload="_Pict.views.HeadlightPanels.removeLoadingSkeleton(this)" />`;
			}
		});

		// if the observation is a PDF or an image, show the skeleton loading class (audio/video tags don't have a skeleton)
		this.pict.MetaTemplate.addPattern('{~UseSkeltonLoading:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpValue = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			const isImage = tmpValue?.Details?.Image?.[0]?.ArtifactType?.toLowerCase() === 'image';
			return isImage ? 'is-skeleton' : '';
		});

		// TODO: since we no longer have full-screen mode, should we remove this pattern?
		// if the observation type is a PDF, use an embed tag, otherwise use an img tag
		this.pict.MetaTemplate.addPattern('{~FullImage:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpValue = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			const isPDF = tmpValue?.Details?.File?.[0]?.Datum?.FileMimeType === 'application/pdf';
			const isVideo = tmpValue?.Details?.Video?.[0]?.ArtifactType?.toLowerCase() === 'video';
			const isImage = tmpValue?.Details?.Image?.[0]?.ArtifactType?.toLowerCase() === 'image';
			let tmpIDArtifact; let tmpVersion;
			// show a PDF viewer if the observation is a PDF file type
			if (isPDF)
			{
				tmpIDArtifact = tmpValue?.Details?.File?.[0]?.IDArtifact;
				tmpVersion = tmpValue?.Details?.File?.[0]?.Version;
				return `<embed class="has-background-text-40 full-size-pdf-with-offsets" src="/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}" onload="_Pict.views.HeadlightPanels.removeLoadingSkeleton(this)" />`;
			}
			// show a video player if the observation is a video file type
			else if (isVideo)
			{
				tmpIDArtifact = tmpValue?.Details?.Video?.[0]?.IDArtifact;
				tmpVersion = tmpValue?.Details?.Video?.[0]?.Version;
				return `<video autoplay class="has-background-text-40 full-size-video-with-offsets" controls><source src="/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}" type="video/mp4"></video>`;
			}
			// show a full size image if the observation is an image file type
			else if (isImage)
			{
				tmpIDArtifact = tmpValue?.Details?.Image?.[0]?.IDArtifact;
				tmpVersion = tmpValue?.Details?.Image?.[0]?.Version;
				return `<img class="has-background-text-40 full-size-image-with-offsets" src="/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}/Full?t=${ new Date().getTime() }" alt="Observation Fullsize" />`;
			}
			// audio doesn't have a full size view, nothing else should be shown
			else
			{
				return `<div class="notification has-text-centered m-3"><span class="icon"><i class="fa fa-fw fa-exclamation-triangle"></i></span><span>No full size available.</span></div>`;
			}
		});

		// if the observation has a map location, show it, otherwise show an image message
		this.pict.MetaTemplate.addPattern('{~ShowMiniMap:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpValue = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			let hasValidCaptureGeoLocation = false;
			let hasValidUserGeoLocation = false;
			// check if the observation has a valid capture or user geolocation
			if (tmpValue?.CaptureLatitude && tmpValue?.CaptureLongitude)
			{
				hasValidCaptureGeoLocation = this.pict.providers.UtilityProvider.isValidLatitude(tmpValue?.CaptureLatitude) && this.pict.providers.UtilityProvider.isValidLongitude(tmpValue?.CaptureLongitude) && (Number(tmpValue?.CaptureLatitude) !== 0 && Number(tmpValue?.CaptureLongitude) !== 0);
			}
			if (tmpValue?.UserLatitude && tmpValue?.UserLongitude)
			{
				hasValidUserGeoLocation = this.pict.providers.UtilityProvider.isValidLatitude(tmpValue?.UserLatitude) && this.pict.providers.UtilityProvider.isValidLongitude(tmpValue?.UserLongitude) && (Number(tmpValue?.UserLatitude) !== 0 && Number(tmpValue?.UserLongitude) !== 0);
			}
			return hasValidCaptureGeoLocation || hasValidUserGeoLocation ? `/1.0/Observation/Map/For/${tmpValue.IDObservation}` : `null`;
		});

		// If the observation has edit capability, show the edit button
		this.pict.MetaTemplate.addPattern('{~CanEdit:', '~}', (pHash, pData, fCallback) =>
		{
			const tmpValue = this.pict.resolveStateFromAddress(pHash, pData, fCallback);
			this.pict.log.info('ObservationDetails:CanEdit:', tmpValue);
			// if the observation is locked, hide the edit button
			if (this.pict.AppData.DocumentData?.ReportData?.Locked)
			{
				return '';
			}
			// if the user does not have CanEdit ability, hide the edit button
			if (!this.pict.AppData.DocumentData?.ReportData?.CanEdit)
			{
				return '';
			}
			if (tmpValue?.Locked)
			{
				return '';
			}
			const template =
					`<button id="ObservationDetails-Content-Edit-Button" type="button" title="Edit Observation Details" class="button is-primary" onclick="_Pict.views.ObservationDetails.observationDetailsEditHandler(event)">
						<span class="icon">
							<i id="ObservationDetails-Content-Edit-Icon" class="fa fa-fw fa-pencil"></i>
						</span>
						<span>Edit Details</span>
					</button>
					<button id="ObservationDetails-Content-Save-Button" type="button" title="Save Observation Details" class="button is-success is-hidden" onclick="_Pict.views.ObservationDetails.observationDetailsSaveHandler(event)">
						<span class="icon">
							<i id="ObservationDetails-Content-Save-Icon" class="fa fa-fw fa-save"></i>
						</span>
						<span>Save Details</span>
					</button>`;
			return template;
		});
	}

	/**
	 * This method resets the state of the Observation Details view to a default state and removes
	 * any active classes on the Image Sets.
	 */
	resetObservationDetailsView()
	{
		if (this.pict?.views?.ObservationSubImageSelector?.intent)
		{
			this.pict.views.ObservationSubImageSelector.intent =
			{
				type: 'Document',
			};
		}
		this.ActiveObservationDetails = {};
	}

	/**
	 * Lifecycle hook that triggers after the view is rendered.
	 *
	 * @param {import('pict-view').Renderable} pRenderable - The renderable that was rendered.
	 */
	onAfterRender(pRenderable)
	{
		const isPDF = this.ActiveObservationDetails?.Details?.File?.[0]?.Datum?.FileMimeType === 'application/pdf';
		if (isPDF)
		{
			const tmpIDArtifact = this.ActiveObservationDetails?.Details?.File?.[0]?.IDArtifact;
			const tmpVersion = this.ActiveObservationDetails?.Details?.File?.[0]?.Version;
			if (!this.pict.views?.PDFViewer)
			{
				this.pict.addView('PDFViewer', Object.assign(libPictSectionPDFJS.default_configuration, { pdfUrl: `/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}` }), libPictSectionPDFJS);
			}
			if (this.pict.views?.PDFViewer)
			{
				this.pict.views.PDFViewer.options.pdfUrl = `/1.0/Artifact/Media/${tmpIDArtifact}/${tmpVersion}`;
				this.pict.views.PDFViewer.render();
			}
		}
		return super.onAfterRender(pRenderable);
	}

	resetObservationTargetPanel()
	{
		if (this.ObservationDetailsBackToSet)
		{
			const observationSetName = document.getElementById('HeadlightPanels-ObservationSet-Title-Wrapper').innerText;
			document.getElementById('HeadlightPanels-ObservationPanel').setAttribute('data-panel-mode', 'add-to-set');
			document.getElementById('HeadlightPanels-ObservationPanel-Observation-Header-Mode-Target').innerText = observationSetName;
			this.pict.views.HeadlightPanels.ModePanelLeft = 'add-to-set';
			this.pict.views.HeadlightPanels.ModePanelRight = 'add-to-set';
			this.pict.views.ObservationSearch.setMode('add-to-set');
		}
	}
	/**
	 * This method returns the user to the Observation List view and resets the Observation Details view.
	 * This method is called when the user clicks the back button in the Observation Details view.
	 * @param {Event} event - The click event
	 * @return {void}
	 */
	returnToPreviousLocation(event)
	{
		// TODO: probably should update this to use data state to track pinned open panels
		if (event && event.target instanceof HTMLElement && event.target.closest('.hl-panel-wrapper').classList.contains('pinned-open'))
		{
			this.log.info('Panel is pinned open, not going back to Observation List view');
			return;
		}
		const tempGroupKey = this.ActiveObservationDetails.ObservationType;
		this.resetObservationDetailsView();
		// go back to the search view if the user came from there
		if (this.ObservationDetailsBackTo === 'Search')
		{
			this.pict.views.HeadlightPanels.handlePanelToggle('Observations', 'open', () =>
			{
				this.resetObservationTargetPanel();
				this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-ObservationPanel-Search', 'Observation');
				this.pict.views.ObservationSearch.updateWithSearchResults(this.pict.views.ObservationSearch.CurrentSearchResults, this.pict.views.ObservationSearch.CurrentSearchResults.length);
			});
		}
		else if (this.ObservationDetailsBackTo === 'Included')
		{
			this.pict.views.HeadlightPanels.handlePanelToggle('Observations', 'open', () =>
			{
				this.resetObservationTargetPanel();
				this.pict.views.HeadlightPanels.toggleTabContent('HeadlightPanels-ObservationPanel-Included', 'Observation');
				this.pict.views.HeadlightPanels.toggleCollapsiblePanelBlockGroup(tempGroupKey, 'open');
			});
		}
		else if (this.ObservationDetailsBackTo === 'ProjectFileSearch')
		{
			this.pict.views.HeadlightPanels.handlePanelToggle('ProjectFileSearch', 'open', () =>
			{
				this.resetObservationTargetPanel();
				this.pict.log.info('Returning to Project Files Search view');
			});
		}
		else
		{
			// close all panels and reset the Observation Details view (same as clicking the close button)
			this.pict.views.HeadlightPanels.closeAllUnpinnedPanels();
			this.pict.views.ObservationDetails.resetObservationDetailsView();
		}
	}

	/**
	 *
	 * @return {number | undefined} the current page being viewed on the PDFViewer
	 */
	getCurrentPage()
	{
		const pageChoice = this.pict.views.PDFViewer.getCurrentPage();
		if (pageChoice && !isNaN(pageChoice))
		{
			return Number(pageChoice);
		}
		return undefined;
	}

	observationDetailsEditHandler(event)
	{
		if (!this.pict.AppData.DocumentData.ReportData.Observations)
		{
			this.log.error(`No Observations; can't update observation details for observation: .`);
			this.pict.views.HeadlightPanels?.toast?.({
				message: `No Observations; can't update observation details for observation: .`,
				type: 'is-danger',
			});
			return;
		}
		// if user clicked the edit button
		if (event)
		{
			// if editable containers exist
			if (document.getElementById('ObservationDetail-Content-Title-Container') && document.getElementById('ObservationDetail-Content-Description-Container'))
			{
				// swap readonlies for inputs
				document.getElementById('ObservationDetails-Content-Title-Readonly').classList.add('is-hidden');
				document.getElementById('ObservationDetails-Content-Title-Edit').classList.remove('is-hidden');
				document.getElementById('ObservationDetails-Content-Description-Readonly').classList.add('is-hidden');
				document.getElementById('ObservationDetails-Content-Description-Edit').classList.remove('is-hidden');
			}
			// if edit button exists
			if (document.getElementById('ObservationDetails-Content-Edit-Button'))
			{
				// change edit aesthetics to save aesthetics
				document.getElementById('ObservationDetails-Content-Edit-Button').classList.add('is-hidden');
				document.getElementById('ObservationDetails-Content-Save-Button').classList.remove('is-hidden');
			}
		}
	}

	async observationDetailsSaveHandler(event)
	{
		if (event)
		{
			event.currentTarget.classList.add('is-loading');
		}
		const tmpObservationDetails = {};
		// TODO: fix this to be "correct" and not use ts-ignore
		/** @ts-ignore */
		const tmpName = document.getElementById('ObservationDetails-Content-Title-Input').value;
		/** @ts-ignore */
		const tmpDescription = document.getElementById('ObservationDetails-Content-Description-Input').value;
		tmpObservationDetails.IDProject = this.pict.AppData.DocumentData.ReportData.IDProject;
		tmpObservationDetails.IDObservation = this.ActiveObservationDetails.IDObservation;
		tmpObservationDetails.Name = tmpName || tmpObservationDetails.Name;
		tmpObservationDetails.Description = tmpDescription || '';
		// TODO: Future enhancement - list documents that contain observation being changed and alert user the title and/or description will change for all
		await this.pict.providers.ObservationProvider.updateObservation(tmpObservationDetails, (observationResult) =>
		{
			this.ActiveObservationDetails = observationResult;
			// Need to update in-memory representation or updated values won't show up when reopening observation
			if (this.AppData?.DocumentData?.ReportData?.Observations && Array.isArray(this.AppData?.DocumentData?.ReportData?.Observations))
			{
				for (let i = 0; i < this.AppData.DocumentData.ReportData.Observations.length; i++)
				{
					if (this.AppData.DocumentData.ReportData.Observations[i].IDObservation === this.ActiveObservationDetails.IDObservation)
					{
						this.AppData.DocumentData.ReportData.Observations[i] = observationResult;
					}
				}
			}
			this.pict.providers.UtilityProvider.removeAllLoadingClasses();
		});
		this.renderAsync(()=>
		{
			this.pict.log.info('Observation Details Updated');
		});
	}

	handlePDFNotesButtonClick(event)
	{
		if (event && event.currentTarget)
		{
			event.currentTarget.classList.add('is-loading');
		}
		this.log.info('PDF Notes button clicked');
		this.pict.views.ObservationSubImageSelector.resetObservationSubImageSelectorView(true, true, this.getCurrentPage());
		this.pict.views.ObservationSubImageSelector.ActiveObservationDetails = this.ActiveObservationDetails;
		this.pict.views.HeadlightPanels.handlePanelToggle('ObservationSubImageSelector', 'open');

		this.pict.providers.UtilityProvider.removeAllLoadingClasses();
	}

	handleAnnotationButtonClick(event)
	{
		if (event && event.currentTarget)
		{
			event.currentTarget.classList.add('is-loading');
		}
		this.log.info('Annotation button clicked');
		this.pict.views.ObservationAnnotation.resetObservationAnnotationView();
		this.pict.views.ObservationAnnotation.ActiveObservationDetails = this.ActiveObservationDetails;
		this.pict.views.HeadlightPanels.handlePanelToggle('ObservationAnnotation', 'open');

		this.pict.providers.UtilityProvider.removeAllLoadingClasses();
	}

	toggleWidth()
	{
		const toggleEl = this.pict.ContentAssignment.getElement('#split-toggle-icon')?.[0];
		const animate = (el)=>
		{
			el.classList.add('fa-flip');
			setTimeout(()=>
			{
				el.classList.remove('fa-flip');
			}, 500);
		};
		if (toggleEl?.classList?.contains('fa-flip-horizontal'))
		{
			animate(toggleEl);
			toggleEl.classList.remove('fa-flip-horizontal');
			this.pict.HeadlightPanels.rightPanelCustomWidth(40);
		}
		else
		{
			animate(toggleEl);
			toggleEl.classList.add('fa-flip-horizontal');
			// 50 has the right panel flush with the left panel. Any more and it covers the left panel.
			this.pict.HeadlightPanels.rightPanelCustomWidth(50);
		}
	}
}

module.exports = ObservationDetails;

module.exports.default_configuration =
{
	ViewIdentifier: 'ObservationDetails',
	DefaultRenderable: 'ObservationDetails',
	DefaultDestinationAddress: '#HeadlightPanels-RightPanel',
	Templates:
	[
		{
			Hash: 'ObservationDetails-Wrapper',
			Template: /*html*/`
			<article id="HeadlightPanels-ObservationDetailsPanel" class="panel is-active panel-content panel-has-nested-scroll-content">
				<p id="HeadlightPanels-ObservationDetailsPanel-Observation-Header" class="panel-heading pr-4">
					<button type="button" class="is-pulled-right hl-panel-close-button" aria-label="close" title="Close panel" onclick="_Pict.views.HeadlightPanels.closeThisPanel(event);_Pict.views.ObservationDetails.resetObservationDetailsView()">
						<span class="icon">
							<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
						</span>
					</button>
					{~TIfAbs:ObservationDetails-BackButton:Record:Pict.views.ObservationDetails.ObservationDetailsBackTo^===^ProjectFileSearch~}
					<button type="button" class="is-pulled-right hl-panel-pin-button mr-2" aria-label="pin" title="Pin content" onclick="_Pict.views.HeadlightPanels.togglePanelPinState('Right')">
						<span class="icon">
							<i class="fas fa-fw fa-thumbtack" aria-hidden="true"></i>
						</span>
					</button>
					<button type="button" class="is-pulled-right mr-2" aria-label="expand" title="Resize observation" onclick="_Pict.views.ObservationDetails.toggleWidth()">
						<span class="icon">
							<i class="fas fa-fw fa-table-layout fa-flip-horizontal" aria-hidden="true" id="split-toggle-icon"></i>
						</span>
					</button>
					<span class="icon">
						<i id="HeadlightPanels-ObservationDetailsPanel-Observation-Header-Icon" class="fas fa-fw fa-image" aria-hidden="true"></i>
					</span>
					<span id="HeadlightPanels-ObservationDetailsPanel-Observation-Header-Title" class="mr-3">Observation Details</span>
				</p>
				<div id="HeadlightPanels-ObservationDetails-Content" class="nested-scroll-content has-bottom-navbar-offset">
					{~T:ObservationDetails-Content:Pict.views.ObservationDetails.ActiveObservationDetails~}
				</div>
			</article>`,
		},
		{
			Hash: 'ObservationDetails-BackButton',
			Template: /*html*/`
				<button type="button" class="is-pulled-right hl-panel-close-button mr-2 {~Show:Pict.views.ObservationDetails.ObservationDetailsBackTo~}" aria-label="back" title="Back to Project Files" onclick="_Pict.views.ObservationDetails.returnToPreviousLocation(event)">
					<span class="icon">
						<i class="fas fa-fw fa-chevron-circle-left" aria-hidden="true"></i>
					</span>
				</button>
			`,
		},
		{
			Hash: 'ObservationDetails-Content',
			Template: /*html*/`
			<div class="container panel-content nested-scroll-content has-bottom-navbar-offset" style="width: 100%;" data-observation-id="{~D:Record.IDObservation~}">
				<figure class="image detail-image-wrapper {~UseSkeltonLoading:Record~}">
					{~PreviewImage:Record~}
				</figure>
				<div class="columns px-5 pt-4 pb-2 mb-0 has-background-text-20">
					{~T:ObservationDetails-Content-Title:Record~}
				</div>
				<div class="columns m-0 p-0 mb-4">
					<div class="column is-6 px-5">
						<span class="title is-block is-6 has-text-text-60">Observation Type</span>
						<span class="subtitle is-6 has-text-text-90">{~ObsTypeDisplay:Record.ObservationType~}</span>
					</div>
					<div class="column p-0">
						{~T:ObservationDetails-Content-Map:Record~}
					</div>
				</div>
				<div class="columns px-5">
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Created by</span>
						<span class="subtitle is-6 has-text-text-90">{~Entity:User^Record.CreatingIDUser^ObservationDetails-Content-User^~}</span>
					</div>
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Designated Time</span>
						<span class="subtitle is-6 has-text-text-90">{~DateFormat:Record.DesignatedTime^MMMM DD, YYYY - hh:mm a^~}</span>
					</div>
				</div>
				{~T:ObservationDetails-Content-Description:Record~}
				<div class="columns px-5">
					<div class="column has-text-right">
						{~CanEdit:Record~}
					</div>
				</div>
				<div class="columns is-multiline px-5">
					{~TS:ObservationDetails-Content-TagType:Pict.providers.ObservationProvider.getObservationTagTypes(Context[0].ActiveObservationDetails)~}
				</div>
			</div>`,
		},
		{
			Hash: 'ObservationDetails-Content-TagType',
			Template: /*html*/`
			<div class="column">
				<span class="label has-text-text-65">{~D:Record.TagType~}</span>
				<div class="tags tag-list">
					{~TS:ObservationDetails-Content-Tag:Pict.providers.ObservationProvider.getObservationTags(Pict.views.ObservationDetails.ActiveObservationDetails,Record.TagType)~}
				</div>
			</div>`,
		},
		{
			Hash: 'ObservationDetails-Content-Title',
			Template: /*html*/`
			<div id="ObservationDetail-Content-Title-Container" class="column">
				<p id="ObservationDetails-Content-Title-Readonly" class="title is-4 has-text-white mb-2">{~D:Record.Name~}</p>
				<p id="ObservationDetails-Content-Title-Edit" class="control is-fullwidth is-relative is-hidden">
					<input 
						id="ObservationDetails-Content-Title-Input"
						class="input has-background-text-30"
						value="{~D:Record.Name~}"
					/>
				</p>
				<p class="subtitle is-6 has-text-text-65">
					<span class="is-pulled-right">
						{~TIfAbs:ObservationDetails-Locked:Record.Locked:Record.Locked^==^1~}
						{~TIfAbs:ObservationDetails-Unlocked:Record.Locked:Record.Locked^==^0~}
					</span>
					<span class="mr-1">#{~D:Record.IDObservation~}</span>
				</p>
			</div>`,
		},
		{
			Hash: 'ObservationDetails-Content-Description',
			Template: /*html*/`
			<div id="ObservationDetail-Content-Description-Container" class="columns px-5">
				<div class="column">
					<p class="title is-6 has-text-text-65 mb-1">Description</p>
					<div id="ObservationDetails-Content-Description-Readonly" class="is-6 has-text-text-90">{~D:Record.Description~}</div>
					<p id="ObservationDetails-Content-Description-Edit" class="control is-fullwidth is-relative is-hidden">
						<textarea 
							id="ObservationDetails-Content-Description-Input"
							class="textarea has-background-text-30"
							rows="2"
						>{~D:Record.Description~}</textarea>
					</p>
				</div>
			</div>`,
		},
		{
			Hash: 'ObservationDetails-Content-Map',
			Template: /*html*/`
			<figure class="image">
				<img onerror="this.onerror = null; this.src='./images/no-location-data-dark.png'" src="{~ShowMiniMap:Record~}" />
			</figure>`,
		},
		{
			Hash: 'ObservationDetails-Content-Tag',
			Template: /*html*/`<span class="tag {~LabelClass:Record~}">{~D:Record.Tag~}</span>`,
		},
		{
			Hash: 'ObservationDetails-Content-User',
			Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
		},
		{
			Hash: 'ObservationDetails-Locked',
			Template: /*html*/`
				<span class="icon has-text-text-95">
					<i class="fas fa-fw fa-sm fa-lock"></i>
				</span>
				<span class="icon-text has-text-text-95">Locked</span>`,
		},
		{
			Hash: 'ObservationDetails-Unlocked',
			Template: /*html*/`
				<span class="icon">
					<i class="fas fa-fw fa-sm fa-unlock"></i>
				</span>
				<span class="icon-text">Unlocked</span>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'ObservationDetails',
			TemplateHash: 'ObservationDetails-Wrapper',
			DestinationAddress: '#HeadlightPanels-RightPanel',
			RenderType: 'replace',
		},
		{
			RenderableHash: 'ObservationDetails-Content',
			TemplateHash: 'ObservationDetails-Content',
			DestinationAddress: '#HeadlightPanels-ObservationDetails-Content',
			RenderType: 'replace',
		},
	],
};
